import React from "react";

// Jds
import { Container, Text } from "@jds/core";
import NotificationItem from "./NotificationItem";

export default function NotificationGroup(props) {
  const { data } = props;
  const title = props.title || "Today";

  //   {
  //     "id": "15cbba74-43d5-4485-acf0-46f84277f060",
  //     "event": "10f505b3-77c7-4e59-a3a7-9d42d2bd56a8",
  //     "title": "willamson26",
  //     "description": "Event details updated! Check now for the latest information.",
  //     "link": null,
  //     "type": "EventUpdated",
  //     "image": "[B@7bd4ce79",
  //     "sourceType": "WEB",
  //     "sender": null,
  //     "receiver": "e2acd425-4f78-4639-81bb-f0c02bd3fe5f",
  //     "isRead": null,
  //     "isArchive": null,
  //     "isActive": true,
  //     "createdAt": "29-05-2024-01:50:14",
  //     "updatedAt": "29-05-2024-01:50:14",
  //     "createdBy": "272c8273-cbe6-4763-9bac-6b37fb21cccc",
  //     "modifiedBy": "272c8273-cbe6-4763-9bac-6b37fb21cccc"
  // },
  return (
    <Container fullWidth direction="column" gap={16}>
      {/* <Text text={title} appearance="body-s-bold" /> */}
      <Container fullWidth direction="column" gap={16}>
        <NotificationItem onClick={props.onClick} data={data} />
      </Container>
    </Container>
  );
}
